<div class="full-width" fxLayout="column">
  <div fxLayout="row" fxFlexOffset="20px" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start start">
      <span class="subtitle-default">Rates & Spaces</span>
      <div fxLayoutGap="10px" fxFlexOffset="30px">
        <button (click)="addLeaseSpaceAndPricing()" class="button-action" mat-flat-button
                *ngIf="showAddButton()"
                [disabled]="loader.loading$ | async">
          <div class="button-text">Add Period</div>
        </button>
        <button (click)="editApplicationSpaceAndPricing()"
                *ngIf="showEditButton()" class="button-action"
                [disabled]="disableEditButton() || (loader.loading$ | async)"
                mat-flat-button>
          <div class="button-text">Edit</div>
        </button>
        <button (click)="editLeasePricingPeriod('values')"
                *ngIf="showEditRatesButton()" class="button-action"
                [disabled]="disableEditRatesButton() || (loader.loading$ | async)"
                mat-flat-button>
          <div class="button-text">Rates & Fees</div>
        </button>
        <button (click)="editLeasePricingPeriod('dates')"
                *ngIf="showEditDatesButton()" class="button-action"
                [disabled]="disableEditDatesButton() || (loader.loading$ | async)"
                mat-flat-button>
          <div class="button-text">Shorten Period</div>
        </button>
        <button (click)="removePanelOpen = true"
                *ngIf="showRemoveButton()"
                class="button-action" mat-flat-button
                [disabled]="disableRemoveButton() || (loader.loading$ | async)">
          <div class="button-text">Remove Period</div>
        </button>
        <button (click)="cancelLeaseEdit()"
                *ngIf="editingLease || addingToLease"
                class="button-action" mat-flat-button
                [disabled]="(loader.loading$ | async)">
          <div class="button-text">Cancel</div>
        </button>
      </div>
      @if (removePanelOpen) {
        <app-confirm-remove (confirmRemove)="removePricingPeriod($event)"
                            [message]="'Are you sure you want to remove this lease period?'"></app-confirm-remove>
      }
    </div>

    <div>
      @if (editingLease) {
        <app-info-panel [type]="PanelType.INFO"
                        [message]="['Hint: Modify the selected rate and spaces below. Cancel at any time to return to the rates overview without saving.']"></app-info-panel>
      } @else {
        @if (leaseSummary?.leaseStatus == 'INVALID') {
          <app-info-panel [type]="PanelType.ERROR"
                          [message]="['There are spaces that overlap with one or more approved or active leases. Change the spaces or end the overlapping lease(s).']"></app-info-panel>

        } @else if (leasePricingPeriodDataSource && leasePricingPeriodDataSource.data.length == 0) {
          <app-info-panel [type]="PanelType.ERROR"
                          [message]="['Lease does not have any rates and charges information']"></app-info-panel>
        }
      }
    </div>
  </div>

  @if (isSubLease) {
    @if (editingLease) {
      <div class="full-width pt-3">
        <app-manage-sublease-booking [offering]="offering"
                                     [editType]="'edit'"
                                     [lease]="leaseSummary!"
                                     [parentLease]="parentLease!"
                                     [pricingPeriod]="leasePricingPeriodDataSource.data[0] ?? null"
                                     (bookingSubmitted)="reloadLeaseSpaceAndPricing($event)"
        ></app-manage-sublease-booking>
      </div>
    }
    @if (addingToLease) {
      <div class="full-width pt-3">
        <app-manage-sublease-booking [offering]="offering"
                                     [editType]="'add'"
                                     [lease]="leaseSummary!"
                                     [parentLease]="parentLease!"
                                     (bookingSubmitted)="reloadLeaseSpaceAndPricing($event)"
        ></app-manage-sublease-booking>
      </div>
    }
  } @else {
    @if (editingLease) {
      <div class="full-width pt-3">
        <app-manage-booking [offering]="offering"
                            [editType]="'edit'"
                            [lease]="leaseSummary!"
                            [pricingPeriod]="leasePricingPeriodDataSource.data[0] ?? null"
                            (bookingSubmitted)="reloadLeaseSpaceAndPricing($event)"
        ></app-manage-booking>
      </div>
    }

    @if (addingToLease) {
      <div class="full-width pt-3">
        <app-manage-booking [offering]="offering"
                            [editType]="'add'"
                            [lease]="leaseSummary!"
                            (bookingSubmitted)="reloadLeaseSpaceAndPricing($event)"
        ></app-manage-booking>
      </div>
    }
  }


  @if (!editingLease && !addingToLease) {
    @if (showRates && leasePricingPeriodDataSource && leasePricingPeriodDataSource.data.length > 0) {
      <div class="radius-10 bg-white mat-elevation-z3" fxLayout="column" fxFlexOffset="30px">

        @if (leasePricingPeriodDataSource.data.length > 0) {
          <table [dataSource]="leasePricingPeriodDataSource" class="custom-table" mat-table
                 matSort matSortActive="startDate" matSortDirection="asc"
                 [multiTemplateDataRows]="true">
            <ng-container matColumnDef="table-label">
              <th *matHeaderCellDef [attr.colspan]="pricingPeriodDisplayedColumns.length" class="custom-table-label"
                  mat-header-cell>
                Pricing Period & Assigned Spaces
              </th>
            </ng-container>

            <ng-container matColumnDef="select">
              <th *matHeaderCellDef mat-header-cell></th>
              <td *matCellDef="let row" class="custom-table-cell" mat-cell>
                <mat-checkbox (change)="$event ? setSelectedPricingPeriod(row) : null"
                              (click)="$event.stopPropagation()"
                              [checked]="pricingPeriodSelection.isSelected(row)"
                              [disabled]="leaseSummary?.leaseType == 'APPLICATION'"
                              color="primary">
                </mat-checkbox>
              </td>
            </ng-container>

            <!--        RATES COLUMNS-->

            <ng-container matColumnDef="uuid">
              <th *matHeaderCellDef mat-header-cell> ID</th>
              <td *matCellDef="let element" class="custom-table-cell" mat-cell> {{ utils.displayUuid(element.uuid) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="rentalPricingOption">
              <th *matHeaderCellDef mat-header-cell>Rental Type</th>
              <td *matCellDef="let element" class="custom-table-cell"
                  mat-cell>{{ getRentalType(element.rentalPricingOption, element) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="includedDays">
              <th *matHeaderCellDef mat-header-cell>Included Days</th>
              <td *matCellDef="let element" class="custom-table-cell"
                  mat-cell>{{ getIncludedDays(element) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="fixedRentalPricingValue">
              <th *matHeaderCellDef mat-header-cell>Rental Fee</th>
              <td *matCellDef="let element" class="custom-table-cell"
                  mat-cell>{{ utils.displayRandAmountWithDecimal(element.fixedRentalPricingValue) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="rentalPricingTurnoverPercentageValue">
              <th *matHeaderCellDef mat-header-cell>Turnover Fee</th>
              <td *matCellDef="let element" class="custom-table-cell"
                  mat-cell>{{ utils.displayNumber(element.rentalPricingTurnoverPercentageValue) }} %
              </td>
            </ng-container>

            <ng-container matColumnDef="applyTransactionFee">
              <th *matHeaderCellDef mat-header-cell>Apply Transaction Fees</th>
              <td *matCellDef="let element" class="custom-table-cell"
                  mat-cell>{{ element.applyTransactionFee ? 'Yes' : 'No' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="startDate">
              <th *matHeaderCellDef mat-header-cell>Start Date</th>
              <td *matCellDef="let element" class="custom-table-cell"
                  mat-cell> {{ displayDate(element.startDate) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="endDate">
              <th *matHeaderCellDef mat-header-cell>End Date</th>
              <td *matCellDef="let element" class="custom-table-cell"
                  mat-cell> {{ displayDate(element.endDate) }}
              </td>
            </ng-container>

            <!--        EXPANSION TOGGLE-->

            <ng-container matColumnDef="expand">
              <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button aria-label="expand row" (click)="toggle(element); $event.stopPropagation()">
                  @if (isExpanded(element)) {
                    <mat-icon>keyboard_arrow_up</mat-icon>
                  } @else {
                    <mat-icon>keyboard_arrow_down</mat-icon>
                  }
                </button>
              </td>
            </ng-container>

            <!--        EXPANDED CONTENT-->

            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->

            <ng-container matColumnDef="expandedDetail">
              <td mat-cell class="p-0" *matCellDef="let element" [attr.colspan]="pricingPeriodDisplayedColumns.length">
                <div class="example-element-detail" [@detailExpand]="isExpanded(element) ? 'expanded' : 'collapsed'">
                  <app-lease-spaces-table class="full-width p-10" #spacesTable
                                          tableStyle="dashboard"
                                          [id]="id"
                                          [offering]="offering"
                                          [pricingPeriod]="element"
                                          (forceDisableEdit)="disablePricingPeriodEdit(element, $event)"></app-lease-spaces-table>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['table-label']" class="custom-table-header"></tr>
            <tr mat-header-row *matHeaderRowDef="pricingPeriodDisplayedColumns" class="custom-table-header"></tr>
            <tr mat-row (click)="toggle(row); $event.stopPropagation()"
                *matRowDef="let row; columns: pricingPeriodDisplayedColumns;"
                [class.example-expanded-row]="isExpanded(row)"
                [class.row-hovered]="isHovered(row)"
                (mouseenter)="setHovered(row)"
                (mouseleave)="clearHovered()"
                class="custom-table-row btn-cursor example-element-row"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
                class="example-detail-row"
                [class.row-hovered]="isHovered(row)"
                (mouseenter)="setHovered(row)"
                (mouseleave)="clearHovered()"></tr>
          </table>
        } @else {
          <app-info-panel [type]="PanelType.INFO"
                          [message]="['Lease does not have any rates and charges information']"></app-info-panel>
        }

      </div>
    }

    @if (!showRates && leasePricingPeriodDataSource && leasePricingPeriodDataSource.data.length == 0) {
      <div fxLayout="row" fxFlexOffset="20px">
        <app-lease-spaces-table class="full-width"
                                tableStyle="custom"
                                [id]="id"
                                [offering]="offering"></app-lease-spaces-table>
      </div>
    }
  }
</div>

